// Stubbed: the OCR/barcode pipeline (tesseract.js + @zxing) was
// removed from this branch. The Consumer Intake Estimate's step-vehicle
// still calls decodeVinFromImage on the capture path; we return a
// no-vin-found result so the existing "scan-failed → type it in"
// fallback handles the case cleanly without a hard error.
//
// Re-enable by restoring vin-scanner-pipeline.ts, public/tesseract/,
// and reinstating tesseract.js + @zxing/* in package.json.

export type VinFromImageResult =
  | { ok: true; vin: string; source: "barcode" | "ocr"; confidence: number }
  | { ok: false; reason: "no-vin-found" | "image-load-failed" }

export async function decodeVinFromImage(
  _file: File,
): Promise<VinFromImageResult> {
  return { ok: false, reason: "no-vin-found" }
}
